import { Skeleton, Stack } from '@mui/material';

export const LargeListSkeleton = () => {
    return (
        <Stack spacing={2}>
            <Skeleton variant="rectangular" height={104} />
            <Skeleton variant="rectangular" height={104} />
            <Skeleton variant="rectangular" height={104} />
            <Skeleton variant="rectangular" height={104} />
            <Skeleton variant="rectangular" height={104} />
            <Skeleton variant="rectangular" height={104} />
        </Stack>
    );
};
